import React, { useContext, useEffect, useState } from "react";
import Percent from "../../../Assets/Modals/Percent.svg";
import { AddCouponFormContext } from "../../../Context/Coupons/AddCouponFormContext";
import { showToast } from "../../../Components/Toaster/Toaster";
import Info from "../../../Assets/Info.svg";
import Rupee from "../../../Assets/Modals/RupeeGray.svg";
import { sanitizeToPositiveInteger } from "../../../lib/utils/utils";

function SetPercentage() {
  const [displayTagTooltip, setDisplayTagTooltip] = useState(false);
  const [visible, setVisible] = useState(false);

  const { formInputs, setFormInputs, maxDiscount, setMaxDiscount, formErrors } =
    useContext(AddCouponFormContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = sanitizeToPositiveInteger(value);
    if (cleanedValue > 100) {
      showToast("Can't be greater than 100.", "warning");
    } else if (cleanedValue < 0) {
      showToast("Can't be less than 0.", "warning");
    } else {
      setFormInputs({ ...formInputs, [name]: cleanedValue });
    }
  };

  const handleMaxDiscountChange = (e) => {
    const { value } = e.target;
    const cleanedValue = sanitizeToPositiveInteger(value);
    setMaxDiscount(cleanedValue);
  };

  useEffect(() => {
    if (displayTagTooltip) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [displayTagTooltip]);

  return (
    <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
      <div className="flex items-center justify-between">
        <h1 className="font-semibold text-[18px] leading-6 text-[#121212]">
          Set Discount Value
        </h1>

        <p className="text-[14px] leading-5 text-[#DC2626] select-none">
          {formErrors.percentage}
        </p>
      </div>

      <div className="flex items-center gap-3">
        <label
          htmlFor="discount-percentage"
          className="font-normal text-[16px] leading-8 text-[#121212] cursor-pointer w-[196px]"
        >
          Percentage Discount
        </label>

        <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg w-[200px] h-14 flex items-center gap-2 focus-within:border-primaryColor">
          <input
            className="w-[calc(100%-24px)] bg-transparent outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666]"
            type="text"
            placeholder="0"
            id="discount-percentage"
            name="percentage"
            value={formInputs.percentage}
            onChange={handleChange}
          />

          <div className="size-6 flex items-center justify-center">
            <img src={Percent} alt="" />
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <label
          htmlFor="maximum-discount"
          className="font-normal text-[16px] leading-8 text-[#121212] cursor-pointer flex items-center gap-1 w-[196px]"
        >
          Maximum Discount Cap
          <div className="relative w-6 h-6 flex items-center justify-center">
            <div className="w-4 h-4 flex items-center justify-center">
              <img
                onMouseEnter={() => setDisplayTagTooltip(true)}
                onMouseLeave={() => setDisplayTagTooltip(false)}
                className="w-full h-full cursor-pointer"
                src={Info}
                alt=""
              />
            </div>

            {displayTagTooltip && (
              <div
                className={`${
                  visible ? "opacity-100 visible" : "opacity-0 invisible"
                } transition-all delay-500 ease-in-out absolute z-10 top-6 left-[20%]`}
              >
                <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[10px] border-b-[#000000]"></div>
                <div className="relative right-1/2 w-[320px] p-3 bg-[#000000] rounded-lg">
                  <p className="font-normal text-[12px] leading-5 text-[#FFFFFF]">
                    Maximum discount cap is the highest discount a customer can
                    get with this coupon. For example, with 40% OFF up to ₹500
                  </p>
                </div>
              </div>
            )}
          </div>
        </label>

        <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg w-[200px] h-14 flex items-center gap-2 focus-within:border-primaryColor">
          <div className="size-6 flex items-center justify-center">
            <img src={Rupee} alt="" />
          </div>

          <input
            name="maxDiscount"
            className="w-[calc(100%-24px)] bg-transparent outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666]"
            type="text"
            placeholder="0"
            id="maximum-discount"
            value={maxDiscount}
            onChange={handleMaxDiscountChange}
          />
        </div>
      </div>
    </div>
  );
}

export default SetPercentage;
